import { render, staticRenderFns } from "./productHeader.vue?vue&type=template&id=1f598210&scoped=true&"
import script from "./productHeader.vue?vue&type=script&lang=js&"
export * from "./productHeader.vue?vue&type=script&lang=js&"
import style0 from "./productHeader.vue?vue&type=style&index=0&id=1f598210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f598210",
  null
  
)

export default component.exports